import { HTMLProps } from 'react';
import { DynamicComponent } from 'yoso';

export type Props = {
  className?: string;
};

export type OptionProps<T = HTMLProps<HTMLOptionElement>> = DynamicComponent<Props, T>;
export const Option = <T,>({ as: As = 'option', ...props }: OptionProps<T>) => <As {...props} />;
